module.exports = __webpack_public_path__ + "img/Golvsliparna.a91e0078.png";